import Caixa from './Caixa'
import HeaderVerde from './HeaderVerde'
import Observacoes from './Observacoes'
import React from 'react'

import { useSelector, useDispatch } from 'react-redux'

const Dificuldades = (props) => {
    const modulo = props.modulo
    const ficha = useSelector((state) => state.addForm.modulos)

    return (
        <Caixa>
            <HeaderVerde texto="DIFICULDADES ENCONTRADAS NA VISITA" />
            <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={0} nome="dificuldades" label=" " />
        </Caixa>
    )
}

export default Dificuldades